// extracted by css-extract-rspack-plugin
export default {"chip":"lrszWEKr7_QyHjnG","neutral":"NZD8xYIEfUp62Tu2","info":"BmsVRMsJOgKBSIMO","success":"OAmoRbrq7QD9nfvQ","warning":"kKpp8j7ZpAfLhRmr","danger":"q_NVgVuuNLUsM8yp"};